import { FC, useContext } from "react";

import { MemberDependent } from "@/App/api/member";
import { MemberEligibilityContext } from "@/App/context/MemberEligibilityContext";
import { MemberEligibilityMember } from "@/App/types";

import { DiscountCardFront } from "./DiscountCard";
import { NonDiscountCardFront } from "./NonDiscountCard";
import { UnifiedCardFront } from "./UnifiedCard";

import { useIsDiscountUser, useShowUnifiedCard } from "../../hooks";

interface MemberCardFrontProps {
  readonly selectedPerson?: MemberEligibilityMember | MemberDependent;
}

export const MemberCardFront: FC<MemberCardFrontProps> = ({ selectedPerson }) => {
  const { memberEligibility } = useContext(MemberEligibilityContext);
  const { isDiscountUser } = useIsDiscountUser();
  const { showUnifiedCard } = useShowUnifiedCard();

  if (isDiscountUser) {
    return <DiscountCardFront memberEligibilityInfo={memberEligibility} selectedPerson={selectedPerson} />;
  } else if (showUnifiedCard) {
    return <UnifiedCardFront memberEligibilityInfo={memberEligibility} selectedPerson={selectedPerson} />;
  } else {
    return <NonDiscountCardFront memberEligibilityInfo={memberEligibility} selectedPerson={selectedPerson} />;
  }
};
